import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HighchartsMore from 'highcharts/highcharts-more';

HighchartsMore(Highcharts);

const MintInfoChart = ({ data }) => {
	// Aggregate data by date and tier
	const aggregateData = data.reduce((acc, { date, tier }) => {
		if (!acc[date]) {
			acc[date] = { total: 0, tier1: 0, tier2: 0 }; // Initialize for each date
		}

		// Increment total count
		acc[date].total += 1;

		// Add to tier totals
		if (tier === 1) {
			acc[date].tier1 += 0.001;
		} else if (tier === 2) {
			acc[date].tier2 += 0.0012;
		}

		return acc;
	}, {});

	// Prepare data for Highcharts
	const categories = Object.keys(aggregateData);
	const seriesData = categories.map(date => ({
		name: date,
		y: aggregateData[date].total,
		tier1: aggregateData[date].tier1,
		tier2: aggregateData[date].tier2
	}));

	// Highcharts options
	const options = {
		chart: {
			type: 'column', // Column chart for better clarity
			backgroundColor: null, // Transparent background
		},
		title: {
			text: 'Mint Key Events'
		},
		xAxis: {
			categories: categories,
			title: {
				text: 'Date'
			}
		},
		yAxis: {
			title: {
				text: 'Count'
			},
			allowDecimals: false
		},
		series: [{
			name: 'Mint Events',
			data: seriesData,
			color: '#DD6B20', // Color of the column
			// tooltip: {
			// 	formatter: function () {
			// 		return `
			//                   <b>${this.x}</b><br/>
			//                   Total Mint Events: <b>${this.y}</b><br/>
			//                   Tier 1 Sum: <b>${this.point.tier1.toFixed(4)}</b><br/>
			//                   Tier 2 Sum: <b>${this.point.tier2.toFixed(4)}</b>
			//               `;
			// 	}
			// }
		}],
		plotOptions: {
			column: {
				dataLabels: {
					enabled: true
				}
			}
		},
		credits: {
			enabled: false, // Disable credits
		}
	};

	return <HighchartsReact highcharts={Highcharts} options={options} />;
};

export default MintInfoChart;
